<app-view-tour-pages gaCategory="View Tutorial">

    <app-view-tour-page>

        <app-view-tour-slide title="Rotate" [trigger]="'camera-rotate'">
            Tap and drag with one finger to change the viewing angle.
        </app-view-tour-slide>

        <app-view-tour-slide>
            <app-view-tour-success></app-view-tour-success>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide title="Zoom" [trigger]="triggers.CameraZoom">
            Pinch with two fingers to zoom in or out.
        </app-view-tour-slide>

        <app-view-tour-slide>
            <app-view-tour-success></app-view-tour-success>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide title="Pan" [trigger]="triggers.CameraPan">
            Use two fingers to adjust the model's position. 
        </app-view-tour-slide>

        <app-view-tour-slide>
            <app-view-tour-success></app-view-tour-success>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide title="Explore the Anatomy" [trigger]="triggers.NodeSelection">
            Tap on an individual part of the model to highlight anatomy.
        </app-view-tour-slide>

        <app-view-tour-slide>
            <div class="flex justify-start items-center">
                <div>
                    <app-view-tour-success [inline]="true" class="mr-2"></app-view-tour-success>
                    <strong class="text-semibold">Tip:</strong> Double-tap to zoom in on specific structures.
                </div>
            </div>
        </app-view-tour-slide>

    </app-view-tour-page>

    <app-view-tour-page>

        <app-view-tour-slide title="Toolbar" image="assets/images/tutorial/tutorial-toolbar@3x.png">
            Use the toolbar to navigate through the 3D experience, launch deeper exploration tools, and relaunch this tutorial.
            <div class="flex flex-column items-center justify-center" slide-footer>

                <button 
                    gaEvent
                    gaAction="Clicked Start Exploring"
                    app-view-rounded-button
                    buttonType="solid"
                    label="Start Exploring!"
                    aria-label="Start Exploring"               
                    class="mt-4"
                    (click)="handleStartClick()">
                </button>         

            </div>
            
        </app-view-tour-slide>

    </app-view-tour-page>

</app-view-tour-pages>